<template>
  <div id="createDictionary">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{path:'/DictionariesList',query: {skillId: this.skillId,online:this.online}}">词典列表</el-breadcrumb-item>
      <el-breadcrumb-item>创建词典</el-breadcrumb-item>
    </el-breadcrumb>
    <div id="intentionInfo">
      <p class="title">创建词典</p>
      <div class="intentionContainer">
        <el-form label-width="110px" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="词典中文名" prop="Chinese">

            <el-tooltip content="词典中文名称(2~50个字符,仅支持中文) 保证技能内唯一" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
            </el-tooltip>
            <el-input v-model='ruleForm.Chinese' type='text' :minlength="2" :maxlength="50"
                      placeholder="请输入中文名称" @input.native="changeRoute"></el-input>
          </el-form-item>
          <el-form-item label="词典标识名" prop="distinguish">
            <el-tooltip content="词典调用名称(2~50个字符,仅支持数字,字母,下划线) 保证技能内唯一" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
            </el-tooltip>
            <el-input v-model='ruleForm.distinguish' type='text' :minlength="2" :maxlength="50"
                      placeholder="请输入调用名称" @input.native="changeRoute"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div id="oftenInfo">
      <p class="title">
        <span>词表</span>
        <el-button type="primary" round size="mini" class="pull-right" @click="dialogFormVisible = true">批量导入</el-button>
        <!-- <el-button type="primary" round size="mini" class="pull-right">导出</el-button> -->
      </p>
      <div class="intentionContainer">
        <el-table
          class="dictionaries-table table text-center"
          :data="tableData"
          style="width: 100%;text-align: center;">
          <el-table-column
            align="center"
            prop="value"
            label="填写词"
            >
            <template slot-scope="scope">
              <div class="sort-button">
                <el-input class="slotButton" type='text' v-model='scope.row.value' @blur="onlyNum(scope.row)"
                          placeholder="请输入填写词"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="synonyms"
            label="同义词"
            align="center"
            >
            <template slot-scope="scope">
              <div class="sort-button">
                <el-input width='500px' class="slotButton" type='text' v-model='scope.row.synonyms'
                          @blur="onlyNum(scope.row)" placeholder="请输入同义词"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="操作"
            align="center"
            >
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small" v-if='scope.row.date==""'>添加词条
              </el-button>
              <el-button @click="deleteRow(scope.row)" type="text" size="small" v-else><i
                class="el-icon-circle-close deleteIcon"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div style="padding:0 30px" id="table_list">
          <table class="table text-center">
            <thead>
            <tr>
              <th class="text-center">填写词</th>
              <th class="text-center">同义词</th>
              <th class="text-center">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <input type="text" class="input_text">
              </td>
              <td>
                <input type="text" class="input_text" placeholder="请输入中文名称">
              </td>
              <td>
                <a href="###">添加槽位</a>
                <button class="btn">X</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>-->
        <div class='page'>
          <el-button class="intentSavebtn" type="primary" round id="Preservation" size="mini" @click='onSubmit' v-if='showSave'>保存</el-button>
          <el-button class="intentSavebtn" type="primary" round id="Preservation" size="mini" @click='onSubmit1' v-else >保存</el-button>
          <p>{{content}}</p>
        </div>
      </div>

    </div>
    <el-dialog
      title="批量导入"
      :visible.sync="dialogFormVisible"
      width="40%"
      :before-close="handleClose">
      <el-upload class="fileUpLoad"
                 id="fileUpLoad"
                 :action="uploadUrl()"
                 :show-file-list="false"
                 :on-success="handleFileSuccess"
                 :before-upload="beforeFileUpload"
                 :on-error="failUpload"
                 :headers="headers"
      >
        <el-button type="primary" size="mini">导入词典文件</el-button>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大小不要超过10M</span>
      </el-upload>
      <!--<el-upload class="fileUpLoad" action="string" :http-request="upload"-->
                 <!--:show-file-list="false"-->
                 <!--:on-success="handleFileSuccess"-->
                 <!--:before-upload="beforeFileUpload"-->
                 <!--:file-list="fileList">-->
        <!--<el-button type="primary" @click="removeItem">导入词典文件</el-button>-->
        <!--<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;大小不要超过10M</span>-->
      <!--</el-upload>-->
      <p class="filePrompt">导入CSV 格式的词库文件,只支持utf8编码,内容格式请参考：<a href="../../../../static/images/template.csv"
                                                               download="template.csv"><span class='muban'>模板.csv</span></a>
      </p>
      <!-- 	<div class='grey'>  <span style="color:#67c23a">导入成功:&nbsp;&nbsp;&nbsp;</span>成功&nbsp;n&nbsp;条&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;失败&nbsp;n&nbsp;条&nbsp;&nbsp;&nbsp;&nbsp;重复&nbsp;n&nbsp;条</div> -->
      <div class='grey' v-show='filename'><span style="color:#67c23a">导入成功:</span>{{filename}}</div>

      <!--  <el-button @click="dialogFormVisible = false">取 消</el-button> -->
      <!--  <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button> -->
    </el-dialog>
    <!--  <div class='page'>
       <el-pagination
         background
         layout="prev, pager, next"
         :total="100">
       </el-pagination>
     </div> -->

    <!--  <div style='height:100px'></div>-->

  </div>
</template>
<script>
  import * as API from '@/api'
  import config from '@/config/index'
  export default {
    data() {
      var checkDis = (rule, value, callback) => {
        // if (!value) {
        //      return callback(new Error('字典识别名'));
        //    }
        setTimeout(() => {
          // var reg = new RegExp("^[\u4e00-\u9fa5]+$");
          var reg = new RegExp("^[a-zA-Z0-9_]+$");
          if (!reg.test(value)) {
//            this.$message.error('请输入正确的字典标识，仅支持数字，字母，下划线')
            callback(new Error('仅支持数字，字母，下划线'));
          } else {
            callback();
          }
          // if (!Number.isInteger(value)) {
          //   callback(new Error('请输入数字值'));
          // } else {
          //   if (value < 18) {
          //     callback(new Error('必须年满18岁'));
          //   } else {
          //     callback();
          //   }
          // }
        }, 100);
      }
      var checkChinese = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5]+$");
          if (!reg.test(value)) {
//            this.$message.error('请输入正确的字典名，2~50个汉字')
            callback(new Error('仅支持中文'));
          } else {
            callback();
          }
        }, 100);
      }
      return {
        skillId: this.$route.query.skillId,
        online: this.$route.query.online,
        tableData1: [{
          date: '帮我查询明天上午的火车',
        }, {
          date: '2016-05-04',
        }],
        tableData: [{
          date: '',
          value: '',
          synonyms: ''
        }],
        ruleForm: {
          Chinese: '',
          distinguish: '',
        },

        rules: {
          Chinese: [
            {required: true, message: '请输入字典中文名', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个汉字', trigger: 'blur'},
            {validator: checkChinese, trigger: 'blur'}
          ],
          distinguish: [
            {required: true, message: '请输入字典识别名', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'},
            {validator: checkDis, trigger: 'blur'}
          ],
        },
        fileList: [{
          name: 'food.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }, {
          name: 'food2.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }],
        dialogFormVisible: false,
        formDataFile: '',
        showSave: true,
        filename: '',
        fileContent: '',
        content: '',
        cc: [],
        tabindexNum:"-1",
        // bg:require('../../../../static/images/template.csv'),
      }
    },
    created(){
      this.tabindexNumChange()
    },
      computed: {
        headers () {
            return {
                'authorization': this.getCookie('token')
            }
        }
      },
    methods: {
         getCookie (name) {
            if (document.location.host == 'opentw.ainirobot.com') {
                name = name + '_tw'
            }
            let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
            if(arr=document.cookie.match(reg)) {
                return arr[2]
            } else {
                return null;
            }
        },
        failUpload (err, file, fileList) {
            console.log(err)
            console.log(file)
            console.log(fileList)
        },
        uploadUrl() {//动态写入地址
            return `${config.host}/user/upload`
             // return 'http://10.100.37.21:5000/dicts/upload'
            // return `${config.host}/nlu/dicts/upload`
        },
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
      tabindexNumChange(){
        this.tabindexNum = "-1";
      },
      handleClick: function (ele) {
//        console.log(this.tableData)
        if (this.tableData[0].value !== '') {
          let reg = /[^\u4e00-\u9fa5A-Za-z]/g
          if (reg.test(this.tableData[0].value)) {
            this.$message({message: '请填写正确填写词,仅中英文', type: 'error'})
            return
          }
          let reg2 = /[^\u4e00-\u9fa5,a-zA-Z]/g
          if (reg2.test(this.tableData[0].synonyms)) {
            this.$message({message: '请填写正确同义词,仅中英文、英文逗号', type: 'error'})
            return
          }
          delete this.tableData[0].date
          this.tableData.unshift(
            {
              date: '',
              value: '',
              synonyms: ''
            })

        } else {
          this.$message.error('填写词不能为空')
          return;
        }
        // console.log('211112')
        // console.log(this.tableData)

      },
      onlyNum(row) {
        //row.rerank = parseInt(row.rerank) || 0;
      },
      deleteRow(row) {
        // this.$options.methods.openNotifyConfirm.bind(this)(row);
        this.$confirm('是否删除此词表?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        let index = this.tableData.indexOf(row);
        this.tableData.splice(index, 1);
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      openNotifyConfirm(row) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
       async writeFile () {

        },
        // 上传成功
      async handleFileSuccess(res, file) {
             let data = {
                 'url': res.data.url
             }
          let response = await API.writeFile(data)
          for (let i = 0; i < response.data.data.length; i++) {
              const re = response.data.data[i];
              re.synonyms = re.synonyms.join(',')
              if (file) {
                  this.filename = file.name

              }
              this.tableData.push(re)
          }
          setTimeout(() => {
              this.dialogFormVisible = false
              this.filename = ''
          }, 500)
      },
      removeItem () {
        localStorage.removeItem("cc")
      },
      // upload(item) {
      //   this.showSave = false;
      //   setTimeout(() => {
      //     this.dialogFormVisible = false;
      //   }, 1000)
      //   if (typeof(FileReader) !== 'undefined') {
      //     var reader = new FileReader();
      //     reader.readAsText(item.file, 'UTF-8');
      //     //reader.readAsText(item.file[0] );            //以文本格式读取
      //     reader.onload = function (evt) {
      //       var data = evt.target.result;        //读到的数据
      //
      //       // console.log(data.indexOf('\n'))
      //       let cc = data.split('\n')
      //       let params = []
      //       cc = cc.slice(0, cc.length - 1)
      //       for (let i = 0; i < cc.length; i++) {
      //         let index = cc[i].indexOf(',')
      //         // console.log(index)
      //         params.push({
      //           'value': cc[i].substring(0, index),
      //           'synonyms': cc[i].substring(index + 1,)
      //         })
      //       }
      //       let dd = {'params': params}
      //       dd = JSON.stringify(dd)
      //       localStorage.setItem("cc", dd)
      //       let params2 = JSON.parse(localStorage.getItem("cc"))
      //       let arrayList = params2.params
      //       arrayList.unshift({
      //         date: '',
      //         value: '',
      //         synonyms: ''
      //       })
      //       this.tableData = arrayList;
      //     }.bind(this)
      //   } else {
      //     alert("IE9及以下浏览器不支持，请使用Chrome或Firefox浏览器");
      //   }
      //   // this.content=localStorage.getItem('data')
      //   // let c= this.content.indexOf(' ')
      //   // console.log(c)
      //   // this.content=this.content.substring(0, c)
      //
      //
      //   // console.log('上传图片接口-参数', item.file)
      //   // upLoadPicFromWeApp(formData).then(res => {
      //   //   console.log('上传图片接口-数据', res)
      //   //   this.formInline.pic_data[this.picIdx].img_url = res.msg
      //   // }).catch(err => {
      //   //   this.$message.error('上传失败，请重新上传')
      //   //   console.log('报错', err)
      //   // })
      // },
      beforeFileUpload(file) {
        // console.log(file.type)
        var fileSize = 0;
        if (file.size > 1024 * 1024) {
          var Size = Math.round(file.size * 100 / (1024 * 1024)) / 100;
          if (Size > 10) {
            this.$alert('文件不能大于10M', '温馨提示', {});
            return false;
          }
          fileSize = (Math.round(file.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
        }
        else {
          fileSize = (Math.round(file.size * 100 / 1024) / 100).toString() + 'KB';
        }
//        console.log(file.type)
        if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
          this.$alert('请上传csv的格式文件', '温馨提示', {});
          return false;
        }
      },
      handleClose(done) {
        done();
        // this.$confirm('确认关闭？')
        //   .then(_ => {
        //     done();
        //   })
        //   .catch(_ => {});
      },
      // muban(fileName, content){
      //   // console.log('121221')
      //   var aLink = document.createElement('a');
      //   var blob = new Blob([content]);
      //   var evt = document.createEvent("HTMLEvents");
      //   evt.initEvent("click", false, false);//initEvent 不加后两个参数在FF下会报错, 感谢 Barret Lee 的反馈
      //   aLink.download = fileName;
      //   aLink.href = URL.createObjectURL(blob);
      //   aLink.dispatchEvent(evt);
      // },
      async sub (params) {
        let res = await API.postCreate(this.skillId, params)
        if (res.code == 200) {
          if (res.data.error) {
            this.$message.error('词典中文名或标识名已存在')
            this.$root.scroll_top()
            return
          } else {
            this.$message({
              message: '创建词典成功',
              type: 'success'
            })
          this.$router.push({path: '/dictionariesList', query: {skillId: this.skillId}})
          }
        } else {
          this.$message.error('当前网络状况异常，请稍后再试');
        }

      },
       onSubmit() {
         let reg = /[^\u4e00-\u9fa5A-Za-z]/g
         let reg2 = /[^\u4e00-\u9fa5,A-Za-z]/g
         for (let i = 0; i < this.tableData.length; i++) {
           let cur = this.tableData[i]
           if (reg.test(cur.value)) {
             this.$message({message: '请填写正确填写词,仅中英文', type: 'error'})
             return
           }
           if (reg2.test(cur.synonyms)) {
             this.$message({message: '请填写正确同义词,仅中英文、英文逗号', type: 'error'})
             return
           }
         }
         this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            var words = [];
            this.tableData[0].value = '';
            this.tableData[0].synonyms = '';
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].value !== '') {
                words.push({'value': this.tableData[i].value, 'synonyms': this.tableData[i].synonyms.split(',')})
              }
            }
            let params = {
              "customized_dict": [
                {
                  "dict_name": this.ruleForm.distinguish,
                  "chinese_name": this.ruleForm.Chinese,
                  "words": words
                }]
            }
            this.sub(params)
          } else {
            this.$root.scroll_top()
          }
        })
      },
      onSubmit1() {
        // console.log(this.fileContent)
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            var words = [];
            this.tableData[0].value = '';
            this.tableData[0].synonyms = '';
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].value !== '') {
                words.push({'value': this.tableData[i].value, 'synonyms': this.tableData[i].synonyms.split(',')})
              }
            }
            //console.log(words)
            let params = {
              "customized_dict": [
                {
                  "dict_name": this.ruleForm.distinguish,
                  "chinese_name": this.ruleForm.Chinese,
                  "words": words,
                  "filedata": ''
                }]
            }
//            console.log('传输的参数', params)
            // console.log('上传图片接口-参数', item.file)
            API.postCreate(this.skillId, params).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '创建词典成功',
                  type: 'success'
                });
                localStorage.removeItem("data");
//                console.log('上传接口-数据', res)
                this.$router.push({path: '/dictionariesList', query: {skillId: this.skillId}})
              } else {
                this.$message.error(res.msg);
              }
            }).catch(err => {
              this.$message.error('连接错误');
            })

          } else {
            this.$root.scroll_top()
          }
        })
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">

  #createDictionary {
    height:100%;
    background: #f7f7f7;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 16px;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
      .pull-right {
        float: right;
        margin: 20px 30px 0 0;
      }
    }
    #intentionInfo {
      background: #fff;

    }
    .intentionContainer {
      padding: 20px 30px;
    }
    .el-input__inner {
      width: 420px;
      height: 28px;
      line-height: 28px;
      border-radius: 14px;
    }
    #oftenInfo {
      background: #fff;
      margin-top: 26px;
      #table_list {
        table {
          margin: 0;
          td {
            position: relative;
            input {
              position: absolute;
              left: 0;
              top: 0;
              padding: 10px;
              border: none;
              outline: none;
            }
          }
        }
      }
    }

    .blurIcon {
      color: #7abaf1;
    }
    .el-form-item {
      position: relative;
      .blurIcon {
        color: #7abaf1;
        position: absolute;
        left: -18px;
      }
    }

    .page {
      /*margin-left: 300px;
      margin-top:30px;
      margin-bottom:30px;*/
      text-align: center;
      margin-top: 30px;
    }
    .dict {
      width: 100px;
    }
    .deleteIcon {
      font-size: 20px;
      color: #ccc;
    }
    .deleteIcon:hover {
      color: #f56c6c;
    }
    .fileUpLoad {
      margin: 0px auto;
    }
    .filePrompt {
      margin-top: 10px;
    }
    .muban {
      color: #6db5ff;
      cursor: pointer;
    }
    .grey {
      background: #f7f7f7;
      padding-left: 20px;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .el-form-item {
      position: relative;
      .blurIcon {
        color: #7abaf1;
        position: absolute;
        left: -18px;
      }
    }

    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    .el-form-item__label{
      padding-right: 20px;
    }
    .dictionaries-table{
      td{
        text-align: center;
      }
    }
    .sort-button{
      margin: 0 auto;
      .el-input__inner{
        width: 80%;
        margin: 0 auto;
        border-radius: 14px;
        text-align: center;
      }
    }
    .intentSavebtn {
      width: 90px;
      height: 32px;
      i {
        margin-top: -10px;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skill/dictionaries/CreateDictionaries.vue